import {Form, FormikProps} from "formik";
import useToastNotify from "../../../hook/useToastNotify";
import React, {useEffect} from "react";
import Input from "../../Elements/Form/Input";
import InputFile from "../../Elements/Form/InputFile";
import Button from "../../Elements/Button";
import {ITicketReplayFormData} from "../../../contracts/data/ticket";

const InnerReplyTicketForm = (props: FormikProps<ITicketReplayFormData>) => {
    const {toastNotify} = useToastNotify()

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
        }
    }, [props.status])

    return(
        <React.Fragment>
            <Form>
                <div className={"w-full py-3"}>
                    <Input name={"content"} as={'textarea'} label={"متن پاسخ تیکت"} placeholder={"متن پاسخ تیکت..."}
                           meta={props.getFieldMeta('content')} defaultValue={props.values?.content} isRequired/>
                    <InputFile name={"attachment"} accept={".jpg,.jpeg,.png,.zip,.rar,.pdf"} label={"فایل پیوست شده"}
                               meta={props.getFieldMeta('attachment')} handleUploadFile={props.setFieldValue}
                               defaultValue={props.values?.attachment}
                    />
                </div>
                <div className={"text-right"}>
                    <Button title={"ثبت پاسخ"} isLoading={props.isSubmitting}/>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default InnerReplyTicketForm
